/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";

import { SelectWithSearch } from "@/components/form-input";
import { createPortal } from "react-dom";
import { XIcon } from "lucide-react";
// import { SynonymType } from "../user-input/synonym-type";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  order_type: any;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  order_type,
}: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  if (!open) return null;

  return createPortal(
    <div className="fixed left-0 top-0 w-full h-full z-[99] flex items-center justify-center">
      <span
        className="absolute left-0 top-0 w-full h-full bg-black/50"
        onClick={() => onOpenChange(false)}
      ></span>
      <div className="bg-white relative w-[500px] rounded-md">
        <div>
          <div className="flex justify-between items-center px-5 py-3 pr-1">
            <div className="">Create Domain</div>
            <Button
              variant={"ghost"}
              size={"icon"}
              onClick={() => onOpenChange(false)}
            >
              <XIcon />
            </Button>
          </div>
          <hr className="" />
          <div className="">
            <div className="">
              <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                  <div className="flex flex-col gap-4 px-5 py-4">
                    <FormField
                      control={form.control}
                      name="domain_name"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel>Domain name</FormLabel>
                          <FormControl>
                            <Input placeholder="Domain name" {...field} />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                    <FormField
                      control={form.control}
                      name="order_type"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel>Order type</FormLabel>
                          <FormControl>
                            <SelectWithSearch
                              placeholder="Select Order type"
                              value={field.value}
                              onChange={field.onChange}
                              bindValue="value"
                              bindLabel="label"
                              // disabled={isNew ? true : false}
                              options={order_type}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                  <hr className="mt-5" />
                  <div className="flex px-5 py-4 gap-3 ">
                    <Button
                      type="submit"
                      className="w-[120px]"
                      disabled={form.formState.isSubmitting}
                    >
                      {form.formState.isSubmitting ? (
                        <IconRender
                          name="LoaderCircle"
                          className="w-5 animate-spin text-white zoom-in-150"
                        />
                      ) : (
                        "Save"
                      )}
                    </Button>
                    <Button
                      type="submit"
                      onClick={() => onOpenChange(false)}
                      variant={"outline"}
                      className="w-[120px]"
                    >
                      Close
                    </Button>
                  </div>
                </form>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
